export default __webpack_public_path__ + "static/N0112-2b24eb1ab4e5f878594f08806ac1af74.png";